export default {
  customerSettlements: [],
}
